import { useMemo } from 'react'
import { useFeedConfig } from '../contexts/feedConfigContext'
import { useHostFormat } from './hostFormat'
import { createTranslator, type Translator } from './translator'

export * from './translator'

/** The chrome language of the organization in ConfigContext, formatted for its host. */
export function useI18n(): Translator {
  const { organization } = useFeedConfig()
  const { locale: hostLocale } = useHostFormat()
  return useMemo(() => createTranslator(organization, hostLocale), [organization, hostLocale])
}
